module.exports = __webpack_public_path__ + "img/hohlschnitt_lichtgrau_ral7035.ae3ec2fc.jpg";